<div *ngIf="prikaziStranicu" class="container-fluid">
    <h2 class="content-block">RADNI NALOZI - DOKUMENTI</h2>
  
    <div class="content-block dnevniPlanWrapper">
      <div class="selectDates">
        <div class="odabirDatuma">
          <label>Datum od:</label>
          <dx-date-box
            [(value)]="datumOd"
            [(max)]="datumDo"
            pickerType="calendar"
            displayFormat='dd.MM.yyyy.'
            width="200"
            (onValueChanged)="onValueChangedDatumOd($event)"
          >
          </dx-date-box>
        </div>
        <div class="odabirDatuma">
          <label>Datum do:</label>
          <dx-date-box
            [(value)]="datumDo"
            [(min)]="datumOd"
            pickerType="calendar"
            displayFormat='dd.MM.yyyy.'
            width="200"
            (onValueChanged)="onValueChangedDatumDo($event)"
          >
          </dx-date-box>
        </div>
      </div>

      
    <div class="customTable dnevniPlan">
      <dx-data-grid
        id="izvjestajRND"
        [dataSource]="rnDokumenti"
        noDataText="{{ poruka }}"
        [wordWrapEnabled]="true"
        keyExpr="nl_id"
        [showBorders]="false"
        [showColumnLines]="true"
        [columnAutoWidth]="true"
        [columnMinWidth]="60"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onSelectionChanged)="filtrirajDokumente($event)"
        (onRowClick)="onRowClick($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Popis radnih naloga s pripadajućim dokumentima</h2>
            <p class="mt-0">Kliknite na nalog za prikaz detalja</p>
          </div>
        </div>

        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-selection mode="single"></dxo-selection>

        <dxi-column
          dataField="nl_zadatum"
          dataType="date"
          caption="Datum"
          [width]="120"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="nl_broj"
          caption="Broj RN"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="smjena_idsmjena"
          caption="Smjena"
          [width]="120"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="datumivrijemepocetka"
          caption="Početak RN"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="datumivrijemezavrsetka"
          caption="Završetak RN"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="ar_sifra"
          caption="Šifra artikla"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="ar_naziv"
          caption="Naziv artikla"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="planproizvodnje_idplanproizvodnje"
          caption="Plan"
          [width]="110"
          alignment="left"
        ></dxi-column>
        <dxo-master-detail
          [enabled]="false"
          template="detail"
        ></dxo-master-detail>

        <div *dxTemplate="let data of 'detail'">
          <p *ngIf="popisDokumenataRN.length == 0">Dohvaćanje podataka...</p>
          <div *ngIf="popisDokumenataRN.length > 0">
            <!-- DOKUMENTI -->
            <div class="dokumenti">
              <p style="margin: 1rem 0 0.5rem">Dokumenti:</p>
              <dx-tree-list
                [dataSource]="popisDokumenataRN"
                [wordWrapEnabled]="true"
                keyExpr="pz_broj"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [columnWidth]="100"
              >
                <dxi-column
                  dataField="DV_NAZIV"
                  caption="Naziv dokumenta"
                  [width]="250"
                ></dxi-column>
              </dx-tree-list>
            </div>
          </div>
        </div>
      </dx-data-grid>
    </div>

    </div>
</div>